import { C_ACTION } from '../constans';

let order_id;
let new_state;

export const orders = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_ORDERS: {
      return [...action.data];
    }
    case C_ACTION.CHANGE_ORDER_PROVIDER: {
      order_id = state.findIndex(item => item.id === action.id_order);
      new_state = [...state];
      new_state.splice(order_id, 1, {
        ...action.item,
        providerId: action.provider.providerId,
        provider: action.provider.providerId,
        provider_name: action.provider.name,
      });

      return new_state;
    }
    case C_ACTION.CHANGE_ORDER_CATEGORY: {
      order_id = state.findIndex(item => item.id === action.id_order);
      new_state = [...state];
      new_state.splice(order_id, 1, {
        ...action.item,
        category: action.category,
      });

      return new_state;
    }
    case C_ACTION.CHANGE_ORDER: {
      order_id = state.findIndex(item => item.id === action.id);

      console.log(order_id);
      new_state = [...state];
      new_state.splice(order_id, 1, { ...action.item });
      return new_state;
    }

    case C_ACTION.DELETE_ORDERS: {
      return [];
    }

    default:
      return state;
  }
};
